import * as React from "react";
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';
import {RouteComponentProps} from "react-router";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";
import {PostApiService} from "../../core/api/post/PostApiService";

interface IProps extends RouteComponentProps {
    componentName?: string;
}

interface IState {
    data: IReadNewsResponse;
    params: any;
}

export class NewsDetail extends React.Component<IProps, IState> {

    private readonly postService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: {} as IReadNewsResponse,
            params: this.props.match.params
        };
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="news-detail" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 agenda-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">{this.state.data.title}</h1>
                                <div className="hs-line-4 font-alt black">{this.state.data.dateTime}</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Berita</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1">
                                <div className="blog-item mb-80 mb-xs-40">
                                    <div className="blog-item-body">
                                        <div className="blog-media mt-40 mb-40 mb-xs-30">
                                            <ul className="clearlist content-slider">
                                                <li><img src={this.state.data.image} alt={this.state.data.title} /></li>
                                            </ul>
                                        </div>
                                        <p>
                                            {this.state.data.description}
                                        </p>
                                    </div>
                                </div>
                                <div className="clearfix mt-40">
                                    <a className="blog-item-more left" href="#">&nbsp;Prev post</a>
                                    <a className="blog-item-more right" href="#">Next post&nbsp;</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                <Footer />
            </div>
        );
    }

    private fetchData = () => {
        this.postService.readNewsDetail(this.state.params.detail)
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: {} as IReadNewsResponse
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/screen/news/NewsDetail.tsx